import { createGnarClient, GnarClient, MemoryGnarClient } from '@grammarly/gnar-app-client'
import type { EventProps } from '@grammarly/gnarclientweb'
import type { User } from '@lib/services/user'
import { Cookie, getCookie } from '@lib/utils/cookies'
import { BUILD_TAG, SERVICE_NAME } from '../../../constants'
import { getConfig } from '../../../config'
import { GnarSpec } from './spec'

export { EventProps }

const { tracking, domains } = getConfig()

let eventExtraProps = {}

const bindExtraProps = (client: GnarClient): GnarClient => {
  const originalTrack: (props: EventProps) => Promise<void> = client.track.bind(client)
  client.track = (props: EventProps) => originalTrack({ ...props, ...eventExtraProps })
  return client
}

export const extendGnarEventsWith = (props: Omit<EventProps, 'eventName'>): EventProps => {
  eventExtraProps = { ...props, ...eventExtraProps }
  return eventExtraProps as EventProps
}

export const setGnarUser = (user: User) => {
  gnarClient.setUser(user.id, user.isTest || !!getCookie(Cookie.AutoTest))
}

export const gnarClient = IS_CLIENT_SIDE
  ? bindExtraProps(createGnarClient(tracking.gnar.url, SERVICE_NAME, BUILD_TAG, domains.cookie))
  : new MemoryGnarClient()

export const gnarSpec = new GnarSpec(gnarClient)
